import React, { useEffect, useState } from "react";
import { getIcon } from "utils/iconsConfig";
import "./calendarHeaderStyle.css";
import CustomYearSelect from "../calendar_year/CustomYearSelect";
import { ReactComponent as LeftArrow } from "../../../../../assets/orderClient/cal_left_arrow.svg";
import { ReactComponent as RightArrow } from "../../../../../assets/orderClient/cal_right_arrow.svg";

const CalendarHeader = ({ date, changeYear, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
  const years = [];
  const currentYear = new Date().getFullYear();

  // Example: allow selection from 50 years back to 10 years ahead
  for (let year = currentYear - 50; year <= currentYear + 10; year++) {
    years.push(year);
  }

  return (
    <div
      style={{
        margin: "10px 10px 0px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // padding: '0 10px'
      }}
    >
      {/* Month and Year on the left */}
      <div style={{ display: "flex", alignItems: "center", columnGap: "3px" }}>
        <span className="month-text">{date.toLocaleString("default", { month: "long" })}</span>
        {/* <select
                    value={date.getFullYear()}
                    onChange={(e) => changeYear(Number(e.target.value))}
                    className='selection-year'
                >
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select> */}
        <CustomYearSelect selectedYear={date.getFullYear()} onYearChange={changeYear} startYear={currentYear - 30} endYear={currentYear + 10} />
      </div>

      {/* Arrows on the right */}
      <div>
        <button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{
            marginRight: "5px",
            background: "none",
            border: "none",
            fontSize: "1.2rem",
            cursor: "pointer",
          }}
        >
          <LeftArrow />
        </button>
        <button
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{
            // border:"0.5px solid black !important",
            background: "none",
            border: "none",
            fontSize: "1.2rem",
            cursor: "pointer",
          }}
        >
          <RightArrow />
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;
